<template>
  <lottie 
    :options="defaultOptions"
    :width="width"
    :height="height"
    @animCreated="handleAnimation"
  />
</template>

<script>
import Lottie from 'vue-lottie/src/lottie.vue'
import animationData from '../../../../assets/lotties/hooksVoice.json'

export default {
  name: 'VoiceIcon',
  components: {
    lottie: Lottie
  },
  props: {
    isHovered: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      defaultOptions: {
        animationData: animationData,
        loop: true,
        autoplay: false
      }
    }
  },
  watch: {
    isHovered (val) {
      if (val) {
        this.anim.play()
      } else {
        this.anim.stop()
      }
    }
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim
      this.anim.setSpeed(0.8)
    }
  }
}
</script>

<style scoped></style>